module.exports = __webpack_public_path__ + "media/recipes/103-31ca02fb.png";